import {Component, HostListener, Input, OnInit} from "@angular/core";
import {MoreInfoInterface, RoomDetailsInterface} from "../../../shared/interfaces/room-type.interface";
import {ViewportRuler} from "@angular/cdk/overlay";

@Component({
  selector: "sw-package-details-body",
  templateUrl: "./package-details-body.component.html",

})
export class PackageDetailsBodyComponent implements OnInit {
  @Input() package?: string;
  @Input() details?: MoreInfoInterface;
  @Input() id?: string;
  private screenWidth: number = 0;

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.screenWidth = event.target.innerWidth; // Update the screen width on window resize
  }

  currentDetails?: RoomDetailsInterface;

  constructor(private viewportRuler: ViewportRuler) {
      this.screenWidth = this.viewportRuler.getViewportSize().width
  }

  ngOnInit(): void {
    if (this.details)
      this.currentDetails = this.details?.roomDetails[0];
  }

  getImg(name: string | undefined): string {
    if (name === "Plafond / muur")
      return "muur";
    else if (name === "Douche / bad")
      return "douche";
    else if (name === "Wastafel")
      return "wastafel";
    else if (name === "Toilet")
      return "toilet";
    else if (name === "Vloer")
      return "vloer";
    else
      return "reanovation";
  }

  getColumns(items: number | undefined): number {
    if (this.screenWidth > 1024) {
      if (items === 1)
        return 1
      if (items === 2)
        return 2

      return 3
    }

    if (this.screenWidth < 1024 && this.screenWidth > 640)
      return 2

    return 1
  }
}
